<template>
  <ViewFirm
    :id="id"
    :notPopup="false"
    :tablesProp="tablesProp"
    noNote>
  </ViewFirm>
</template>

<script>
  import ViewFirm from "@/components/search/firms/ViewFirm";
  export default {
    name: "ViewFirmNoNote",
    props: {
      id: [String, Number],
      tablesProp: [String],
    },
    components: {
      ViewFirm,
    },
  }
</script>

<style scoped>

</style>
